module.exports = __webpack_public_path__ + "img/sidebar.f812a299.svg";